import { GraphTagsFormValues } from "@features/administration/products/EditProduct/GraphTagsForm/GraphTagsForm"
import { GraphTagRule } from "@features/builder/types"
import { csvContentToRows } from "@utils/file"

export interface GraphTagRow {
  Name: string
  Rule: GraphTagRule
  Description?: string
}

export const GRAPH_TAG_FILE_REQUIRED_HEADERS = ["Name", "Rule"]
export const GRAPH_TAG_FILE_HEADERS = [...GRAPH_TAG_FILE_REQUIRED_HEADERS, "Description"]
export const GRAPH_TAG_RULE_OPTIONS: {
  label: string
  value: GraphTagRule
  description: string[]
}[] = [
  {
    label: "Never",
    value: "Never",
    description: [
      "User does not need to set values of this tag on the graph.",
      "Even if set, won't need to attach it to any of the nodes.",
    ],
  },
  {
    label: "Always",
    value: "Always",
    description: [
      "User does not need to set values of this tag on the graph.",
      "Every node of that graph has to have it attached only if any value has been set for the graph tag.",
    ],
  },
  {
    label: "More than one",
    value: "More than one",
    description: [
      "User does not need to set values of this tag on the graph.",
      "If set with a single value, it means every node of that graph refers to that tag value.",
      "If set with multiple values, then user needs to specify which nodes refer to which tag value.",
    ],
  },
]

export const getRowsFromGraphTagsFileContent = (csvContent: string): GraphTagRow[] => {
  const rows = csvContentToRows(csvContent)

  const headers = rows[0]?.split(",")
  if (!headers) return []

  const requiredColumnsMissing =
    new Set(GRAPH_TAG_FILE_REQUIRED_HEADERS).difference(new Set(headers)).size > 0
  if (requiredColumnsMissing) return []

  const nameIndex = headers.indexOf("Name")
  const ruleIndex = headers.indexOf("Rule")
  const descriptionIndex = headers.indexOf("Description")
  const newRows: GraphTagRow[] = []
  rows.forEach((row, index) => {
    if (index === 0) return
    const arr = row.split(",")
    newRows.push({
      Name: arr[nameIndex] ?? "",
      Rule: (arr[ruleIndex] as GraphTagRule) ?? "Never",
      Description: arr[descriptionIndex] ?? "",
    })
  })
  return newRows
}

export const formValuesToGraphTagsFileContent = (formValues: GraphTagsFormValues) => {
  let value = "Name,Rule,Description\n"
  formValues.rows.forEach((row, index) => {
    value += `${row.name},${row.rule},${row.description}`
    if (index !== formValues.rows.length - 1) value += "\n"
  })

  return value
}
